import { isAccess, isAccessForAll } from "modules/common/utils";
import { ControlLabel, Wrapper, Alert } from "modules/theme";
import PropTypes from "prop-types";
import React, { Component } from "react";
import APIManager from "modules/common/apiManager";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Box, BoxName, Row, RowTitle } from "../styles/main";
import ReportingDropdownMenu from "./ReportingDropdownMenu";
import { globalStateSelector } from "../../../../../store/selector";

export class ReportingTheme extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      listData: [],
      loading: false,
    };
  }
  renderBox(name, image, to, block, accessName) {
    const { __ } = this.context;
    const { accessDefination } = this.props;
    let access = true;
    if (accessDefination && accessDefination[accessName]) {
      access = isAccess(
        accessDefination[accessName].options,
        ["list", "allow-view"],
        accessName
      );
    }

    return (
      access && (
        <Box>
          <Link
            style={!block ? {} : { cursor: "not-allowed" }}
            to={!block ? to : "#"}
          >
            <span class="material-symbols-outlined setting-icon">{image}</span>
            <BoxName>{__(name)}</BoxName>
          </Link>
        </Box>
      )
    );
  }

  getList() {
    this.mAPI.sendGetAPI(
      `setting/dynamic-report`,
      (data) => {
        // this.setState({ loading: false });

        if (data && data.data) {
          this.setState({
            listData: data.data && data.data.message ? data.data.message : [],
          });
        } else {
          this.setState({ listData: [] });
        }
      },
      (error, data) => {
        if (data) {
          // Alert.error(` ${data.message}`);
        } else {
          // Alert.error(`${error}`);
        }
      }
    );
  }

  componentDidMount() {
    document.title = "Reports";
    if (this.props.currentUser && this.props.currentUser.role !== 6) {
      this.getList();
    }
  }

  render() {
    const { __ } = this.context;
    const { currentUser } = this.props;
    let role = currentUser && currentUser.role ? currentUser.role : "";
    let content = <div></div>;
    if (role == 6) {
      content = isAccessForAll(this.props.accessDefination, [
        "agent-outbound-cdr-report",
        "agent-inbound-cdr-report",
      ]) && (
          <div>
            <Row style={{ marginLeft: "20px" }}>
              <RowTitle className="secondRow boxsmall-title">
                {__("Agent")}
              </RowTitle>
            </Row>
            <Row style={{ marginLeft: "20px" }}>
              <div>
                <div>
                  {this.renderBox(
                    __("Outbound"),
                    "call_made",
                    "/reporting/cdr/agent-outbound-cdr-report",
                    false,
                    "agent-outbound-cdr-report"
                  )}
                  {this.renderBox(
                    __("Inbound"),
                    "call_received",
                    "/reporting/cdr/agent-inbound-cdr-report",
                    false,
                    "agent-inbound-cdr-report"
                  )}
                </div>
              </div>
            </Row>
          </div>
        );
    } else {
      content = (
        <div>
          {isAccessForAll(this.props.accessDefination, [
            "voice-cdr-report",
            "outbound-cdr-report",
            "inbound-cdr-report",
            "dnc-cdr-report",
            "dnc-cdr-report",
            "call-report",
          ]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("Global")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    {this.renderBox(
                      __("Voice"),
                      "graphic_eq",
                      "/reporting/cdr/voice-report",
                      false,
                      "voice-cdr-report"
                    )}
                    {this.renderBox(
                      __("Outbound"),
                      "phone_forwarded",
                      "/reporting/cdr/outbound-cdr-report",
                      false,
                      "outbound-cdr-report"
                    )}
                    {this.renderBox(
                      __("Inbound"),
                      "phone_callback",
                      "/reporting/cdr/inbound-cdr-report",
                      false,
                      "inbound-cdr-report"
                    )}
                    {this.renderBox(
                      __("DNC"),
                      "phone_disabled",
                      "/reporting/cdr/dnc-cdr-report",
                      false,
                      "dnc-cdr-report"
                    )}
                    {this.renderBox(
                      __("Call Report"),
                      "graphic_eq",
                      "/reporting/call-report",
                      false,
                      "call-report"
                    )}
                  </div>
                </Row>
              </React.Fragment>
            )}

          {isAccessForAll(this.props.accessDefination, [
            "messsage-cdr-report",
          ]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("Message")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    {this.renderBox(
                      __("Message"),
                      "chat",
                      "/reporting/message-cdr-report",
                      false,
                      "messsage-cdr-report"
                    )}
                    {this.state.listData.map((data, index) => (
                      this.renderBox(
                        data.name,
                        data.icon,
                        `/reporting/message/${data.reportId}`,
                        false,
                        data.reportId
                      )
                    ))}
                  </div>
                </Row>
              </React.Fragment>
            )}

          {isAccessForAll(this.props.accessDefination, [
            "agent-outbound-cdr-report",
            "agent-inbound-cdr-report",
            "agent-outbound-drop-report",
            "agent-inbound-missed-report",
            "user-summary-report",
            "break-summary-report",
            "dispose-summary-report",
            "callback-report",
            "team-summary-report",
            "campaign-summary-report",
            "auto-dispose-summary-report",
          ]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("Agent")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    <div>
                      {this.renderBox(
                        __("Outbound"),
                        "call_made",
                        "/reporting/cdr/agent-outbound-cdr-report",
                        false,
                        "agent-outbound-cdr-report"
                      )}
                      {this.renderBox(
                        __("Inbound"),
                        "call_received",
                        "/reporting/cdr/agent-inbound-cdr-report",
                        false,
                        "agent-inbound-cdr-report"
                      )}
                      {this.renderBox(
                        __("Outbound Drop"),
                        "call_end",
                        "/reporting/cdr/agent-outbound-drop-report",
                        false,
                        "agent-outbound-drop-report"
                      )}
                      {this.renderBox(
                        __("Inbound Drop"),
                        "call_end",
                        "/reporting/cdr/agent-inbound-missed-report",
                        false,
                        "agent-inbound-missed-report"
                      )}
                      {this.renderBox(
                        __("User Summary"),
                        "recent_actors",
                        "/reporting/user-summary",
                        false,
                        "user-summary-report"
                      )}
                      {this.renderBox(
                        __("Break Summary"),
                        "dinner_dining",
                        "/reporting/break-summary",
                        false,
                        "break-summary-report"
                      )}
                      {this.renderBox(
                        __("Dispose Summary"),
                        "workspace_premium",
                        "/reporting/despose-report",
                        false,
                        "dispose-summary-report"
                      )}
                      {this.renderBox(
                        __("Callback"),
                        "reply",
                        "/reporting/callback-report",
                        false,
                        "callback-report"
                      )}
                      {this.renderBox(
                        __("Team Summary"),
                        "groups_2",
                        "/reporting/agent/team-summary",
                        false,
                        "team-summary-report"
                      )}
                      {this.renderBox(
                        __("Campaign Summary"),
                        "campaign",
                        "/reporting/agent/campaign-summary",
                        false,
                        "campaign-summary-report"
                      )}
                      {this.renderBox(
                        __("Auto Dispose Summary"),
                        "time_auto",
                        "/reporting/agent/auto-dispose-summary",
                        false,
                        "auto-dispose-summary-report"
                      )}
                      {role !== 5
                        ? this.renderBox(
                          __("Provider Summary"),
                          "cell_tower",
                          "/reporting/provider-summary",
                          false,
                          "provider-summary-report"
                        )
                        : ""}

                      {role !== 5
                        ? this.renderBox(
                          __("Carrier Status Summary"),
                          "toggle_on",
                          "/reporting/carrier-status-summary",
                          false,
                          "carrier-status-summary-report"
                        )
                        : ""}
                      {/* {this.renderBox(
                      __("Provider Summary"),
                      "cell_tower",
                      "/reporting/provider-summary",
                      false,
                      "provider-summary-report"
                    )} */}
                      {/* {this.renderBox(
                      __("Carrier Status Summary"),
                      "toggle_on",
                      "/reporting/carrier-status-summary",
                      false,
                      "carrier-status-summary-report"
                    )} */}
                      {/* {this.renderBox(
                      __('Agent Heat Map'),
                      'key_visualizer',
                      '/reporting/agent-heat-map'
                      , false,
                      'agent-heat-map-report'
                    )}*/}
                    </div>
                  </div>
                </Row>
              </React.Fragment>
            )}

          {/*{isAccessForAll(this.props.accessDefination, [
						'contact-list-call-statistics-report',
						'lead-status-report',
						'contact-list-quality-assurance',
						'duplicate-lead-identification-report',
					]) && (
						<React.Fragment>
							<Row style={{ marginLeft: '20px' }}>
								<RowTitle className='secondRow boxsmall-title'>
									{__('Lead')}
								</RowTitle>
							</Row>
							<Row style={{ marginLeft: '20px' }}>
								<div>
									<div>
										{this.renderBox(
											__('Contact List Call Statistics'),
											'stacked_bar_chart',
											'/reporting/lead/contact-list-call-statistics',
											false,
											'contact-list-call-statistics-report'
										)}
										{this.renderBox(
											__('Lead Status'),
											'leaderboard',
											'/reporting/lead/lead-status',
											false,
											'lead-status-report'
										)}
										{this.renderBox(
											__('Duplicate Lead Identification Report'),
											'crisis_alert',
											'/reporting/lead/duplicate-lead-identification-report',
											false,
											'duplicate-lead-identification-report'
										)}
										{this.renderBox(
											__('Contact List Quality Assurance Report'),
											'quick_reference_all',
											'/reporting/cdr/contact-list-quality-assurance-report',
											false,
											'contact-list-quality-assurance-report'
										)}
									</div>
								</div>
							</Row>
						</React.Fragment>
					)}
                            */}

          {isAccessForAll(this.props.accessDefination, [
            "broadcast-cdr-report",
          ]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("OBD")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    <div>
                      {this.renderBox(
                        __("Broadcast"),
                        "cell_tower",
                        "/reporting/cdr/broadcast-cdr-report",
                        false,
                        "broadcast-cdr-report"
                      )}
                    </div>
                  </div>
                </Row>
              </React.Fragment>
            )}
          {role !== 5
            ? isAccessForAll(this.props.accessDefination, [
              "cpass-outbound-cdr-report",
              "cpaas-inbound-cdr-report",
            ]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("CPaaS")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    <div>
                      {this.renderBox(
                        __("Outbound"),
                        "call_made",
                        "/reporting/cdr/cpaas-outbound-cdr-report",
                        false,
                        "cpaas-outbound-cdr-report"
                      )}
                      {this.renderBox(
                        __("Inbound"),
                        "call_received",
                        "/reporting/cdr/cpaas-inbound-cdr-report",
                        false,
                        "cpaas-inbound-cdr-report"
                      )}
                    </div>
                  </div>
                </Row>
              </React.Fragment>
            )
            : ""}
          {/* {isAccessForAll(this.props.accessDefination, [
            "cpass-outbound-cdr-report",
            "cpaas-inbound-cdr-report",
          ]) && (
            <React.Fragment>
              <Row style={{ marginLeft: "20px" }}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("CPaaS")}
                </RowTitle>
              </Row>
              <Row style={{ marginLeft: "20px" }}>
                <div>
                  <div>
                    {this.renderBox(
                      __("Outbound"),
                      "call_made",
                      "/reporting/cdr/cpaas-outbound-cdr-report",
                      false,
                      "cpaas-outbound-cdr-report"
                    )}
                    {this.renderBox(
                      __("Inbound"),
                      "call_received",
                      "/reporting/cdr/cpaas-inbound-cdr-report",
                      false,
                      "cpaas-inbound-cdr-report"
                    )}
                  </div>
                </div>
              </Row>
            </React.Fragment>
          )} */}
          {role !== 5 ?
            isAccessForAll(this.props.accessDefination, ["webhook-report"]) && (
              <React.Fragment>
                <Row style={{ marginLeft: "20px" }}>
                  <RowTitle className="secondRow boxsmall-title">
                    {__("Log")}
                  </RowTitle>
                </Row>
                <Row style={{ marginLeft: "20px" }}>
                  <div>
                    <div>
                      {this.renderBox(
                        __("Webhooks"),
                        "graphic_eq",
                        "/reporting/webhooks-report",
                        false,
                        "webhook-report"
                      )}
                    </div>
                  </div>
                </Row>
              </React.Fragment>
            ) : ""}
        </div>
      );
    }
    return (
      <Wrapper
        style={{ margin: "20px" }}
        header={<Wrapper.Header />}
        heading={<ControlLabel>{`Reports`}</ControlLabel>}
        leftSidebar={<ReportingDropdownMenu role={role} />}
        showLeftSideBar={true}
        actionBar={false}
        content={content}
        transparent={false}
      />
    );
  }
}

ReportingTheme.contextTypes = {
  __: PropTypes.func,
};

const mapStateToProps = (state) => ({
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
});

export default connect(mapStateToProps)(ReportingTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ReportingTheme.js